'use client';

import NextLink from 'next/link';
import { Suspense } from 'react';

import { useNavigation } from '@/hooks/navigation/use-navigation.hook';

type NextLinkProps = React.ComponentProps<typeof NextLink>;

/**
 * Next.js Link that appends persisted params (cidade, utm_*, etc.) to internal paths.
 * Wrapped in Suspense so static generation does not run useSearchParams().
 */
function LinkWithResolvedHref({ href, ...props }: NextLinkProps) {
  const { resolveHref } = useNavigation();
  const resolvedHref = typeof href === 'string' && href.startsWith('/') ? resolveHref(href) : href;
  return <NextLink href={resolvedHref} {...props} />;
}

export function Link({ prefetch = false, ...props }: NextLinkProps) {
  return (
    <Suspense fallback={<NextLink {...props} />}>
      <LinkWithResolvedHref prefetch={prefetch} {...props} />
    </Suspense>
  );
}
